import { createFileRoute } from '@tanstack/react-router'

import { LinearSettingsPage } from '#features/integrations/linear/linear-settings-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/linear',
)({
  head: () => ({
    meta: [
      {
        title: 'Linear integration',
      },
    ],
  }),
  component: () => <LinearSettingsPage />,
})
